import { useMutation, useQueryClient } from '@tanstack/react-query';

import { type YatPageItemCreate, type YatPageItemUpdate } from '@app/client';
import { addPortfolioLink, updatePortfolioLink } from '@app/store/actions/yat-page-item-actions';

import { type LinkCardProps } from '../LinkCard';

import { USER_YAT_PAGE_LINKS } from './useGetYatPageLinks';

function useClearLinks() {
    const queryClient = useQueryClient();

    return () => {
        queryClient.invalidateQueries({
            predicate: ({ queryKey }) => queryKey[0] === USER_YAT_PAGE_LINKS,
        });
    };
}

export function useAddLinkMutation(pageId = '') {
    const handleOnSuccess = useClearLinks();

    return useMutation({
        mutationFn: ({ title, url, description, image }: LinkCardProps) => {
            const item = {
                item_type: {
                    Link: {
                        url: url,
                        type: 'url',
                        description: description,
                        title: title,
                        collapsed: false,
                        page_preview: {
                            image: image || '',
                            description: description,
                            title: title,
                            domain: url,
                            image_alt: null,
                            site_name: null,
                            video: null,
                        },
                    },
                },
            } as YatPageItemCreate;
            return addPortfolioLink(item, pageId);
        },
        onSuccess: handleOnSuccess,
    });
}

export function useUpdateLinkMutation(pageId = '') {
    const handleOnSuccess = useClearLinks();

    return useMutation({
        mutationFn: ({ item_id, title, url, description, image }: LinkCardProps) => {
            const item = {
                id: item_id,
                item_type: {
                    Link: {
                        url,
                        description,
                        title,
                        collapsed: false,
                        image,
                    },
                },
            } as unknown as YatPageItemUpdate;

            return updatePortfolioLink(item, pageId);
        },
        onSuccess: handleOnSuccess,
    });
}
